import React, { useContext } from 'react';
import { HashLink } from 'react-router-hash-link';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { AppContext } from '../../contexts/AppContext';
import planALogo from '../../images/plan-a.png';
import appearancePhoto1 from '../../images/plan-a-media-group-plan-a-live-1.png';
import appearancePhoto2 from '../../images/plan-a-media-group-plan-a-live-2.png';
import appearancePhoto3 from '../../images/plan-a-media-group-plan-a-live-3.png';
import appearancePhoto4 from '../../images/plan-a-media-group-plan-a-live-4.JPG';

export default function PlanALive() {
  const { useMobileView } = useContext(AppContext);

  return (
    <Grid
      container
      spacing={3}
      sx={{
        padding: '16px 16px',
        margin: '0px 0px',
        width: '100%',
      }}
    >
      {useMobileView ? (
        <>
          <Grid item xs={12} container justifyContent="center" alignItems="flex-end">
            <img src={planALogo} alt="Plan A Logo" />
            <span style={{ textDecoration: 'underline', fontSize: '28px' }}>Live</span>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center">
              Bring Adrienne and <b>Plan <span style={{ color: 'red' }}>A</span></b> Media Group to your 
              media convention, industry panel, corporate event or fan appearance. 
            </Typography>
            <Typography align="center">
              Adrienne has 20 years of public speaking and fan appearance experiences - from small 
              creative retreats, to University lectures, exclusive industry panels, to massive fan events.
            </Typography>
            <Typography align="center">
              Adrienne is your go-to-gal to connect with audiences - live and virtually - eager to share her 
              experience and to see your own creative projects thrive.  She is happy to detail her own journey 
              through entertainment, to champion yours by sharing her experiences from in-front-of and 
              behind-the-camera and even to bring an entire <b>Plan <span style={{ color: 'red' }}>A </span></b>
              Media Group panel to cover a variety of creative topics to help move your work from idea to screen!    
            </Typography>
            <br />
            <br />
            <Typography align="center">
              <HashLink
                to="/#contact"
                style={{
                  cursor: 'pointer',
                  color: 'white',
                  textDecoration: 'none',
                  fontFamily: 'Montserrat',
                  '&:hover': {
                    color: 'red !important',
                  },
                }}
              >
                <b>Click here</b>
              </HashLink>
              {' '}
              to request <b>Plan <span style={{ color: 'red' }}>A</span> Live</b>!
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Avatar
              variant={"rounded"}
              src={appearancePhoto1}
              alt="Plan A Media Group's Adrienne Wilkinson makes an appearance"
              sx={{ width: '100%', height: '100%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Avatar
              variant={"rounded"}
              src={appearancePhoto2}
              alt="Plan A Media Group's Adrienne Wilkinson makes an appearance"
              sx={{ width: '100%', height: '100%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Avatar
              variant={"rounded"}
              src={appearancePhoto4}
              alt="Plan A Media Group's Adrienne Wilkinson makes an appearance"
              sx={{ width: '100%', height: '100%' }}
            />
          </Grid>
          <Grid item xs={12}>
          <Avatar
              variant={"rounded"}
              src={appearancePhoto3}
              alt="Plan A Media Group's Adrienne Wilkinson makes an appearance"
              sx={{ width: '100%', height: '100%' }}
            />
          </Grid>
          <Grid item xs={2} />
        </>
      ) : (
        <>
          <Grid item xs={12} container justifyContent="center" alignItems="flex-end">
            <img src={planALogo} alt="Plan A Logo" />
            <span style={{ textDecoration: 'underline', fontSize: '28px' }}>Live</span>
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={8}>
            <Typography align="center">
              Bring Adrienne and <b>Plan <span style={{ color: 'red' }}>A</span></b> Media Group to your 
              media convention, industry panel, corporate event or fan appearance. 
            </Typography>
            <Typography align="center">
              Adrienne has 20 years of public speaking and fan appearance experiences - from small 
              creative retreats, to University lectures, exclusive industry panels, to massive fan events.
            </Typography>
            <Typography align="center">
              Adrienne is your go-to-gal to connect with audiences - live and virtually - eager to share her 
              experience and to see your own creative projects thrive.  She is happy to detail her own journey 
              through entertainment, to champion yours by sharing her experiences from in-front-of and 
              behind-the-camera and even to bring an entire <b>Plan <span style={{ color: 'red' }}>A </span></b>
              Media Group panel to cover a variety of creative topics to help move your work from idea to screen!    
            </Typography>
            <br />
            <br />
            <Typography align="center">
              <HashLink
                to="/#contact"
                style={{
                  cursor: 'pointer',
                  color: 'white',
                  textDecoration: 'none',
                  fontFamily: 'Montserrat',
                  '&:hover': {
                    color: 'red !important',
                  },
                }}
              >
                <b>Click here</b>
              </HashLink>
              {' '}
              to request <b>Plan <span style={{ color: 'red' }}>A</span> Live</b>!
            </Typography>
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={2} />
          <Grid item xs={8}>
            <Avatar
              variant={"rounded"}
              src={appearancePhoto1}
              alt="Plan A Media Group's Adrienne Wilkinson makes appearances"
              sx={{ width: '100%', height: '100%' }}
            />
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={2} />
          <Grid item xs={8}>
          <Avatar
              variant={"rounded"}
              src={appearancePhoto2}
              alt="Plan A Media Group's Adrienne Wilkinson makes an appearance at a convention"
              sx={{ width: '100%', height: '100%' }}
            />
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={2} />
          <Grid item xs={8} container justifyContent="center">
            <Avatar
              variant={"rounded"}
              src={appearancePhoto4}
              alt="Plan A Media Group's Adrienne Wilkinson makes an appearance at a convention in 2022"
              sx={{ width: '100%', height: '100%' }}
            />
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={2} />
          <Grid item xs={8} container justifyContent="center">
            <Avatar
              variant={"rounded"}
              src={appearancePhoto3}
              alt="Plan A Media Group's Adrienne Wilkinson appearing on a screenwriter's panel"
              sx={{ width: '100%', height: '100%', maxHeight: '476px', maxWidth: '358px' }}
            />
          </Grid>
          <Grid item xs={2} />
        </>
      )}
    </Grid>
  );
}
